import { cn } from "@/shared/lib/utils";

const TypographyH1 = ({
  children,
  icon,
  uppercase,
  smaller,
  className,
}: {
  children: React.ReactNode
  icon?: React.ReactNode
  uppercase?: boolean
  smaller?: boolean
  className?: string
}) => {
  return (
    <h1
      className={cn(
        "*:scroll-m-20 text-2xl font-bold tracking-tight text-balance",
        icon && "flex items-center gap-2",
        uppercase && "uppercase",
        smaller && "text-xl",
        className,
      )}
    >
      {icon && <span>{icon}</span>}
      {children}
    </h1>
  );
};

export default TypographyH1;
